import { styled } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
"use strict";
const SIZES = {
  large: {
    width: 36,
    height: 36
  },
  medium: {
    width: 18,
    height: 18
  }
};
const Wrap = styled.div`
  display: block;
  color: ${({
  color
}) => {
  if (!color) return theme.colors.white;
  switch (color) {
    case "white":
      return theme.colors.white;
    case "primaryBlue":
      return theme.colors.primaryBlue;
  }
}};
  width: ${({
  size
}) => SIZES[size].width}px;
  height: ${({
  size
}) => SIZES[size].height}px;
`;
export { SIZES, Wrap };
//# sourceMappingURL=LoaderDots.styles.mjs.map
